// src/Dashboard/DashboardLayout.jsx

import React from "react";

import { DashboardLayoutProvider } from "./contexts/DashboardLayoutContext";
import DashboardTopbar from "./components/DashboardTopbar";
import DashboardAsideMenu from "./components/DashboardAsideMenu";
import DashboardMainContent from "./components/DashboardMainContent";
// import DashboardFooter from "./components/DashboardFooter";

import { useNotification } from "../hooks/NotificationContext";
import { useMessage } from "../hooks/MessageContext";
import { useContactForm } from "../hooks/ContactFormContext";
import useCountBump from "../hooks/useCountBump";

export default function DashboardLayout() {
  const { unreadCount } = useNotification();
  const { unreadMessageCount } = useMessage();
  const { unreadCountContactForm } = useContactForm();

  const bumpMessages = useCountBump(unreadMessageCount);
  const bumpNotifications = useCountBump(unreadCount);
  const bumpContactForms = useCountBump(unreadCountContactForm);

  return (
    <DashboardLayoutProvider>
      <div className="min-h-screen bg-slate-100 dark:bg-slate-950">
        <DashboardTopbar
          unreadCount={unreadCount}
          unreadMessageCount={unreadMessageCount}
          unreadCountContactForm={unreadCountContactForm}
          bumpMessages={bumpMessages}
          bumpNotifications={bumpNotifications}
          bumpContactForms={bumpContactForms}
        />

        <DashboardAsideMenu />

        <DashboardMainContent />

        {/* <DashboardFooter /> */}
      </div>
    </DashboardLayoutProvider>
  );
}